import { useVisitorTracking } from '@/hooks/useVisitorTracking';

const VisitorTracker = () => {
  useVisitorTracking();
  return null; // This component doesn't render anything
};

export default VisitorTracker;
